export default {"src":"/_next/static/media/rlc.77ec1a6a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};